import { FOOTER_MJML } from "../common/footer";
import { TRANSACTIONAL_HEADER } from "../common/header";

export const productDemo = `
<mjml>
  <mj-head>
    <mj-title>Join Our Exclusive Product Demo</mj-title>
    <mj-preview>See our product in action and learn advanced features</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
    </mj-attributes>
  </mj-head>
  <mj-body>
    ${TRANSACTIONAL_HEADER(
      "Product Demo Invitation",
      "Discover what our product can do for you"
    )}
    
    <mj-section background-color="#ffffff" padding="30px 0">
      <mj-column>
        <mj-text font-size="22px" color="#333333" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">As a valued user of {{product_name}}, we'd like to invite you to an exclusive live demonstration where our product experts will showcase advanced features and answer your questions.</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f8f9fa" padding="30px">
      <mj-column>
        <mj-text font-size="24px" color="#333333" font-weight="bold" align="center">Virtual Product Demo</mj-text>
        <mj-divider border-color="#6200ea" border-width="2px" width="100px" />
        <mj-text font-size="18px" color="#555555" align="center" padding-top="15px">
          <strong>Date:</strong> {{demo_date}}
        </mj-text>
        <mj-text font-size="18px" color="#555555" align="center" padding="0">
          <strong>Time:</strong> {{demo_time}} ({{timezone}})
        </mj-text>
        <mj-text font-size="18px" color="#555555" align="center" padding="0">
          <strong>Duration:</strong> 60 minutes
        </mj-text>
        <mj-button background-color="#6200ea" color="#ffffff" href="#" width="200px" border-radius="4px" font-weight="bold" font-size="16px">Register Now</mj-button>
        <mj-text font-size="14px" color="#777777" align="center" padding-top="10px">
          Limited spots available. Registration closes {{registration_deadline}}.
        </mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="30px 0">
      <mj-column>
        <mj-text font-size="20px" color="#333333" font-weight="bold">What You'll Learn</mj-text>
        <mj-text font-size="16px" color="#555555">
          Join us for this informative session where we'll cover:
        </mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 0 30px">
      <mj-column width="48%">
        <mj-image src="https://via.placeholder.com/300x180?text=Advanced+Features" alt="Advanced Features" />
        <mj-text font-size="18px" font-weight="bold" align="center">Advanced Features</mj-text>
        <mj-text font-size="16px" color="#555555" align="center">Discover powerful capabilities that most users never explore.</mj-text>
      </mj-column>
      <mj-column width="48%">
        <mj-image src="https://via.placeholder.com/300x180?text=Workflow+Optimization" alt="Workflow Optimization" />
        <mj-text font-size="18px" font-weight="bold" align="center">Workflow Optimization</mj-text>
        <mj-text font-size="16px" color="#555555" align="center">Learn how to streamline your processes and save valuable time.</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 0 30px">
      <mj-column width="48%">
        <mj-image src="https://via.placeholder.com/300x180?text=Best+Practices" alt="Best Practices" />
        <mj-text font-size="18px" font-weight="bold" align="center">Best Practices</mj-text>
        <mj-text font-size="16px" color="#555555" align="center">Expert tips and strategies to maximize your results.</mj-text>
      </mj-column>
      <mj-column width="48%">
        <mj-image src="https://via.placeholder.com/300x180?text=Q%26A+Session" alt="Q&A Session" />
        <mj-text font-size="18px" font-weight="bold" align="center">Live Q&A Session</mj-text>
        <mj-text font-size="16px" color="#555555" align="center">Get your specific questions answered by our product specialists.</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f0f4fd" padding="30px">
      <mj-column width="30%">
        <mj-image src="https://via.placeholder.com/150?text=Speaker" width="150px" border-radius="75px" alt="Product Specialist" />
      </mj-column>
      <mj-column width="70%">
        <mj-text font-size="20px" color="#333333" font-weight="bold">Meet Your Presenter</mj-text>
        <mj-text font-size="18px" color="#444444" font-weight="bold" padding-bottom="5px">{{presenter_name}}</mj-text>
        <mj-text font-size="16px" color="#555555" padding="0">{{presenter_title}}</mj-text>
        <mj-text font-size="16px" color="#555555" padding-top="10px">{{presenter_bio}}</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="30px 0">
      <mj-column>
        <mj-text font-size="18px" color="#555555">
          Even if you can't attend live, register anyway and we'll send you a recording of the session.
        </mj-text>
        <mj-button background-color="#6200ea" color="#ffffff" href="#" border-radius="4px" font-weight="bold">Save Your Spot</mj-button>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "productDemo",
  name: "Product Demo Invitation",
  category: "product",
  description:
    "An engaging invitation to a product demonstration webinar that highlights learning opportunities and presenter expertise.",
  features: [
    "Demo schedule details",
    "Learning objectives",
    "Presenter information",
    "Registration button",
    "Session recording offer",
  ],
  subject: "Join Our Exclusive Product Demo",
  subTitle: "See our product in action and learn advanced features",
  mjmlTemplate: productDemo,
};
